export const MAX_DELTA_REQUIRED_PRESSURE = 1;
export const FREQUENCY_STEP = 5;

export const MAX_MOTOR_LOAD_RATIO = 1.5;
export const MIN_MOTOR_LOAD_RATIO = 0.6;

export const DEFAULT_CABLE_LENGTH_FEET = 100;
export const MLE_ADDITIONAL_LENGTH_FEET = 5;
export const MLE_RECOMMENDED_ADDITIONAL_LENGTH_FEET = 15;

// Steam Assisted Gravity Drain for super thick viscosity that heats it up
// Used in colder climates
export const BMB_LENGTH_SAGD_FEET = 3.59375;
export const BMB_WEIGHT_SAGD_LB = 93;

export const DEFAULT_MOTOR_FREQUENCY_HZ = 60;
export const DEFAULT_ESP_PUMP_RPM = 3500;
export const DEFAULT_HPS_PUMP_RPM = 3570;

export const HB_ADJUSTMENT = 104.4;
export const ORK_ADJUSTMENT = 104.4;

export const WATER_CUT_MAXIMUM = 99.99999999999999;

export const DEFAULT_INPUT_LINE_VOLTAGE_V = 480;

export const PSI_BAR_CONVERSION_FACTOR = 0.0689475729317831;
export const PSI_ATM_CONVERSION_FACTOR = 0.068045963779916;

export const AIR_MOLECULAR_WEIGHT_G_MOL = 28.9652;

export const FALLBACK_OKTA_AUTH_REFRESH_MINUTES = 55;

export const GRAVITY_FT_SEC = 32.17;

export const ISPROD = "production";
export const SURFACE_CABLE = "surface_cable";

export const PUMP_EFFICIENCY = 135575.043478546;

export const TAP_SETTING_LOOKUP_ITERATIONS = 24;

export const DEFAULT_SEAL_MOTOR_OIL = "S6.5";

export const LS_KEY = "default_pumping_type";

export const DEFAULT_HPS_MOTOR_TEMPERATURE_F = 70;

export const VISCOSITY_TEMPERATURE_TYPE = "temperature";
export const VISCOSITY_PRESSURE_TYPE = "pressure";

export const DEFAULT_HAZEN_WILLIAMS_MOTOR_COEFFICIENT = 120;
